<div #Container style="height: 100%; display: flex; flex-direction: column;">
  @if (editorVisible) {
    <quill-editor #Editor [attr.aria-labelledby]="labelId || ''" [modules]="quillmodules" theme="snow" bounds="self"
                  [(ngModel)]="model" [disabled]="disabled" placeholder="" [format]="quillFormat"
                  (onEditorCreated)="initEditor()" (ngModelChange)="valueChanged()"></quill-editor>
  }
</div>
